import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  passwordTipsWrapper: ({ spacing }) => css`
    svg {
      min-width: ${spacing.xs};
      min-height: ${spacing.xs};
    }
  `,
})

export default useStyles
